/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type NewTransactionModal_viewer$ref = any;
export type NewTransactionModalQueryVariables = {};
export type NewTransactionModalQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": NewTransactionModal_viewer$ref;
    };
};
export type NewTransactionModalQuery = {
    readonly response: NewTransactionModalQueryResponse;
    readonly variables: NewTransactionModalQueryVariables;
};



/*
query NewTransactionModalQuery {
  viewer {
    ...NewTransactionModal_viewer
  }
}

fragment NewTransactionModal_viewer on Viewer {
  currentTradePrice {
    zarPerTroyOunce
    usdPerTroyOunce
    zarToUsd
    id
  }
  companies {
    edges {
      node {
        id
        info {
          name
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "NewTransactionModalQuery",
  "id": null,
  "text": "query NewTransactionModalQuery {\n  viewer {\n    ...NewTransactionModal_viewer\n  }\n}\n\nfragment NewTransactionModal_viewer on Viewer {\n  currentTradePrice {\n    zarPerTroyOunce\n    usdPerTroyOunce\n    zarToUsd\n    id\n  }\n  companies {\n    edges {\n      node {\n        id\n        info {\n          name\n        }\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "NewTransactionModalQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": "viewer",
        "name": "__viewer_viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "NewTransactionModal_viewer",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "NewTransactionModalQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentTradePrice",
            "storageKey": null,
            "args": null,
            "concreteType": "TradePrice",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "zarPerTroyOunce",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "usdPerTroyOunce",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "zarToUsd",
                "args": null,
                "storageKey": null
              },
              v0
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "companies",
            "storageKey": null,
            "args": null,
            "concreteType": "ViewerCompaniesConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ViewerCompaniesEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Company",
                    "plural": false,
                    "selections": [
                      v0,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "info",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CompanyInfo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "viewer",
        "args": null,
        "handle": "viewer",
        "key": "",
        "filters": null
      }
    ]
  }
};
})();
(node as any).hash = '9766c1da65829abd4d20985b703b7e10';
export default node;
